const BEAUTY_INSIDER_TAB_KEYS = {
    REWARDS: 'Rewards',
    EARN_POINTS: 'EarnPoints',
    BENEFITS: 'Benefits',
    HISTORY: 'History'
};

const HISTORY_USER_STATES = {
    GUEST: 'guest',
    NON_BI: 'nonBi',
    EMPTY_BI: 'emptyBi',
    INSIDER: 'insider'
};

const HISTORY_SECTION_STATUS = {
    LOADING: 'loading',
    PLACEHOLDER: 'placeholder',
    EMPTY: 'empty',
    POPULATED: 'populated',
    ERROR: 'error'
};

const HISTORY_CARD_STYLES = {
    GREY: 'grey',
    WHITE: 'white'
};

const PROGRAM_LINKS = {
    FAQS: 'faqs',
    TERMS: 'terms'
};

const HISTORY_ROUTES = {
    REWARDS_DETAIL: '/purchase-history?filterby=rewards',
    HISTORY_TAB: '/profile/BeautyInsider#activeTab=History',
    POINTS_HISTORY: '/profile/BeautyInsider/MyPoints#activeTab=History',
    FAQS: '/beauty/beauty-insider-faq',
    SHOP_NOW: '/'
};

export {
    BEAUTY_INSIDER_TAB_KEYS, HISTORY_CARD_STYLES, HISTORY_ROUTES, HISTORY_SECTION_STATUS, HISTORY_USER_STATES, PROGRAM_LINKS
};
